import {
  ALL_TRAFFIC,
  LIVE_TRAFFIC,
  VOD_TRAFFIC,
} from './constants';
// I am keeping the colors
// Probably we may need them
const colorPalette = [
  '#6f00f8',
  '#4100bb',
  '#2a006e',
  '#c00015',
  '#008987',
  '#00ddc6',
  '#ffdf00',
  '#1323ff',
  '#ff0063',
  '#ffbf00',
  '#005f57',
  '#00804e',
  '#424251',
  '#67f300',
  '#e100f3',
  '#960064',
  '#ff0078',
  '#f82e00',
  '#0095fb',
  '#1E88E5',
  '#3949AB',
  '#5E35B1',
  '#4527A0',
  '#283593',
  '#1565C0',
  '#ff5400',
  '#311B92',
  '#0D47A1',
  '#ff9a00',
  '#6200EA',
  '#64DD17',
  '#2962FF',
  '#00796B',
  '#0097A7',
  '#1A237E',
  '#0288D1',
  '#FFAB00',
  '#006064',
  '#004D40',
  '#EF6C00',
  '#00BFA5',
  '#01579B',
  '#00B8D4',
  '#0091EA',
  '#43A047',
  '#C0CA33',
  '#1B5E20',
  '#33691E',
  '#827717',
  '#00C853',
  '#BF360C',
  '#304FFE',
  '#F9A825',
  '#7CB342',
  '#E65100',
  '#FFD600',
  '#FF6D00',
  '#3E2723',
  '#424242',
  '#D84315',
  '#FF3D00',
  '#263238',
  '#377eb8',
  '#ff7f00',
  '#e41a1c',
  '#e377c2',
  '#4daf4a',
  '#984ea3',
  '#ffff33',
  '#a65628',
  '#f781bf',
  '#1f77b4',
  '#2ca02c',
  '#d62728',
  '#9467bd',
  '#8c564b',
  '#bcbd22',
  '#17becf',
  '#ff7f0e',
  '#ffbb78',
  '#98df8a',
  '#ff9896',
  '#c49c94',
  '#f7b6d2',
  '#dbdb8d',
  '#9edae5',
  '#393b79',
  '#5254a3',
  '#6b6ecf',
  '#9c9ede',
  '#637939',
  '#8ca252',
  '#b5cf6b',
  '#8c6d31',
  '#bd9e39',
  '#e7ba52',
  '#e7cb94',
  '#843c39',
  '#ad494a',
  '#d6616b',
  '#e7969c',
  '#7b4173',
  '#a55194',
  '#ce6dbd',
  '#3182bd',
  '#e6550d',
  '#fd8d3c',
  '#fdae6b',
  '#31a354',
  '#74c476',
  '#a1d99b',
  '#756bb1',
  '#636363',
  '#458bf5',
  '#dbb700',
  '#f07800',
  '#00bf9f',
  '#9560d1',
  '#1F497D',
  '#d03070',
  '#81bf30',
  '#f56cd3',
  '#82975D',
  '#bf5668',
];
export default colorPalette;

export const filterColors = [
  '#FFA500', // Orange
  '#0DBA97', // Seafoam
  '#9A010C', // Blood
  '#0D36A1', // Midnight
  '#E25BAA', // Pink
  '#007B88', // Teal
  '#9777ED', // Lavender
  '#9138A7', // Violet
  '#76C0D7', // Light Blue
  '#46B04A', // Green
  '#CE6940', // Rouge
  '#2778C0', // Aqua
  '#CC3A74', // Dark Pink
  '#88C340', // Lime Green
  '#6486DA', // French Blue
  '#F63F2C', // Bright Red
  '#4455C6', // Dark Blue
  '#BD10E0', // Magenta
  '#FF9292', // Salmon
  '#6A8E3B', // Leaf Green
];

export const specialFilterColors = new Map([
  [ALL_TRAFFIC, '#0f93f5'], // Sky Blue
  [LIVE_TRAFFIC, '#6634b9'], // Purple
  [VOD_TRAFFIC, '#ff6347'], // Poppy
]);

export const DEFAULT_FILTER_COLOR = '#0f93f5';

export const overviewFilterColors = [
  '#0D36A1', // Midnight
  '#9138A7', // Violet
  '#F39F5A',
  '#219C90',
  '#2778C0', // Aqua
  '#6486DA', // French Blue
  '#E25BAA', // Pink
  '#BD10E0', // Magenta
  '#4455C6', // Dark Blue
  '#9777ED', // Lavender
];
